import React, { Component } from "react";
import QrReader from "react-qr-reader";
import { Link } from "react-router-dom";
import "./Scan.css";

class Scan extends Component {
  constructor(props) {
    super(props);
    this.state = {
      delay: 300,
      result: "No result"
    };
    this.handleScan = this.handleScan.bind(this);
  }
  handleScan(data) {
    if (data) {
      window.location = data;
    }
  }
  handleError(err) {
    console.error(err);
  }
  render() {
    return (
      <div className="scan">
        <QrReader
          delay={this.state.delay}
          onError={this.handleError}
          onScan={this.handleScan}
          style={{ width: "100%" }}
        />
        <p>Apunte la cámara al código QR</p>
        <Link className="scan-anchor-back" to={"/"}>
          volver a la página de resumen
        </Link>
      </div>
    );
  }
}

export default Scan;



// WEBPACK FOOTER //
// ./src/Scan/Scan.js